// Default to rinkeby
export default process.env.CONTRACT_ADDRESS ||
  '0x0E8b9F5feaEba1464a2Ad225A84880057469C68c';
